<script>
import dayjs from "dayjs"

export default {
  name: "DeviceComment",
  props: {
    text: String,
    title: String,
    author: String,
    date: String,
    isOwner: Boolean
  },
  methods: {
    formatDate(date) {
      if(!date) return ""
      return dayjs(date).format('DD.MM.YYYY')
    },
  }
}
</script>

<template>
  <div class="device-comment p-3 pb-4">
    <p class="has-text-weight-bold mb-3 is-size-14 is-flex is-align-items-center is-justify-content-space-between">
      {{ author }}
      <span class="device-comment__date">{{ formatDate(date) }}</span>
    </p>
    <p class="is-size-6 has-text-weight-bold mb-2">{{ title }}</p>
    <p class="is-size-14">{{ text }}</p>
    <p v-if="isOwner" class="is-flex is-align-items-center is-justify-content-right mt-3" style="gap: 4px">
      <button
        class="button is-warning is-small"
        @click="$emit('edit')"
      >Редактировать</button>
      <button
        class="button is-danger is-small"
        @click="$emit('delete')"
      >Удалить</button>
    </p>
  </div>
</template>

<style scoped>
.device-comment {
  border: 1px solid #dedede;
  border-radius: 8px;
}
.device-comment__date {
  color: #999999;
  font-size: 14px;
  font-weight: 500;
}
.is-size-14 {
  font-size: 15px;
  line-height: 1.3;
}
</style>
